import React from 'react';
import Header from '../components/Header/Header';
import InsightsHero from '../components/InsightsHero/InsightsHero';
import Footer from '../components/Footer/Footer';
import Markets from '../components/Markets/Markets';
import FooterCTA from '../components/FooterCTA/FooterCTA';
import DataPower from '../components/DataPower/DataPower';
import InsightsGrid from '../components/InsightsGrid/InsightsGrid'; 
import Advantage from '../components/Advantage/Advantage';
import WhatsappCTA from '../components/WhatsappCTA/WhatsappCTA';

const InsightsPage = () => {
  return (
    <>
      <Header />
      <main>
        <InsightsHero />
        <Markets />
        <InsightsGrid />
        <WhatsappCTA />
        <Advantage />
        {/* You can add more sections here, like a full list of articles */}
        <DataPower />
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default InsightsPage;